module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "generate"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.header) + " ")]), _vm._v(" "), _c('el-form', {
    ref: "newUserForm",
    staticStyle: {
      "margin-left": "15%",
      "margin-right": "15%",
      "text-align": "left"
    },
    attrs: {
      "label-position": "left",
      "model": _vm.newUserForm,
      "rules": _vm.genRules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Login Name",
      "prop": "login_name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disableLoginName
    },
    model: {
      value: (_vm.newUserForm.login_name),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "login_name", $$v)
      },
      expression: "newUserForm.login_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Type",
      "prop": "user_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.newUserForm.user_type),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "user_type", $$v)
      },
      expression: "newUserForm.user_type"
    }
  }, [_vm._v("System Admin")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    },
    model: {
      value: (_vm.newUserForm.user_type),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "user_type", $$v)
      },
      expression: "newUserForm.user_type"
    }
  }, [_vm._v("Admin")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "User Password",
      "prop": "user_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "required": "",
      "autocomplete": "off",
      "show-password": ""
    },
    model: {
      value: (_vm.newUserForm.user_pwd),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "user_pwd", $$v)
      },
      expression: "newUserForm.user_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Re-type Password",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "required": "",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.newUserForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "checkPass", $$v)
      },
      expression: "newUserForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.newUserForm.name),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "name", $$v)
      },
      expression: "newUserForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "placeholder": "Email Address",
      "clearable": ""
    },
    model: {
      value: (_vm.newUserForm.email),
      callback: function($$v) {
        _vm.$set(_vm.newUserForm, "email", $$v)
      },
      expression: "newUserForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.generating
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e870116e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserForm.vue
// module id = JWEE
// module chunks = 1